import { Stat } from './stat';
import { TotalClick } from './total-click';

export class Statistics {
    stats:Stat[];
    clicks:TotalClick[];

    constructor() {}
}
